import React, { useContext } from 'react';
import { MediaOverlayContext } from '../../context/MediaOverlayContext';
import CameraPanel from '../CameraPanel';
import GalleryPanel from '../GalleryPanel';
import PhotoEditorOverlay from '../PhotoEditorOverlay';
import './MediaOverlay.css';

const MediaOverlay = () => {
  const { isOpen, mode, closeOverlay, addPhoto } =
    useContext(MediaOverlayContext);

  if (!mode) return null;

  return (
    <div className="media-overlay-container">
      {isOpen && mode === 'camera' && (
        <CameraPanel
          onCapture={(photo, options) => addPhoto(photo, options)}
          onClose={closeOverlay}
        />
      )}
      {isOpen && mode === 'gallery' && <GalleryPanel onClose={closeOverlay} />}
      {isOpen && mode === 'photoEditor' && <PhotoEditorOverlay />}
    </div>
  );
};

export default MediaOverlay;
